// extracted by mini-css-extract-plugin
export default {"sponsorBlock":"movie-provider-banner_sponsorBlock__1Bmnj"};